"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MultiplexHandler_1 = __importDefault(require("./MultiplexHandler"));

var CollectingHandler =
/** @class */
function (_super) {
  __extends(CollectingHandler, _super);

  function CollectingHandler(cbs) {
    if (cbs === void 0) {
      cbs = {};
    }

    var _this = _super.call(this, function (name) {
      var _a;

      var args = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
      }

      _this.events.push([name].concat(args)); // @ts-ignore


      if (_this._cbs[name]) (_a = _this._cbs)[name].apply(_a, args);
    }) || this;

    _this._cbs = cbs;
    _this.events = [];
    return _this;
  }

  CollectingHandler.prototype.onreset = function () {
    this.events = [];
    if (this._cbs.onreset) this._cbs.onreset();
  };

  CollectingHandler.prototype.restart = function () {
    var _a;

    if (this._cbs.onreset) this._cbs.onreset();

    for (var i = 0; i < this.events.length; i++) {
      var _b = this.events[i],
          name_1 = _b[0],
          args = _b.slice(1);

      if (!this._cbs[name_1]) {
        continue;
      } // @ts-ignore


      (_a = this._cbs)[name_1].apply(_a, args);
    }
  };

  return CollectingHandler;
}(MultiplexHandler_1.default);

exports.CollectingHandler = CollectingHandler;